// === Import dependencies and utilities ===
import { apiClientCreate } from "./apiClientCreate";
import { store } from "../store";
import { setAuthTokens, setUser } from "../services/reducers/authReducer";
import { setProgress } from "../services/reducers/fileTransferReducer";
import { jwtDecode } from "jwt-decode";
import apiRoutes from "./apiRoutes";

// === Define endpoints ===
const baseUrl = apiRoutes.base_url;
const refreshTokenUrl = baseUrl + apiRoutes.token_refresh;

// === Tokens getters and setters from Redux store ===
function getCurrentAccessToken() {
  const tokens = store.getState().auth.authTokens;
  return tokens ? tokens.access : null;
}

function getCurrentRefreshToken() {
  const tokens = store.getState().auth.authTokens;
  return tokens ? tokens.refresh : null;
}

function setRefreshedTokens(tokens) {
  store.dispatch(setAuthTokens(tokens));
  store.dispatch(setUser(jwtDecode(tokens.access)));
}

// === Logout handler: clears tokens and user from store ===
async function logout() {
  store.dispatch(setAuthTokens(null));
  store.dispatch(setUser(null));
}

// === API client for General JSON-based requests ===
export const apiClient = apiClientCreate({
  options: {
    baseURL: baseUrl,
    timeout: 600000, // 10 minutes (increased for large file uploads)
    headers: {
      "Content-Type": "application/json",
    },
  },
  getCurrentAccessToken,
  getCurrentRefreshToken,
  refreshTokenUrl,
  logout,
  setRefreshedTokens,
});

// === API client Specialized for file uploads with progress tracking ===
export const apiClientFileUpload = apiClientCreate({
  options: {
    baseURL: baseUrl,
    timeout: 600000,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      const progress = Math.round(
        (100 * progressEvent.loaded) / progressEvent.total,
      );
      store.dispatch(setProgress(progress)); // Dispatch upload progress to Redux store
    },
  },
  getCurrentAccessToken,
  getCurrentRefreshToken,
  refreshTokenUrl,
  logout,
  setRefreshedTokens,
});

// === API client Specialized for file downloads (returns blob) ===
export const apiClientFileDownload = apiClientCreate({
  options: {
    baseURL: baseUrl,
    timeout: 600000,
    responseType: "blob", // Expect binary response
  },
  getCurrentAccessToken,
  getCurrentRefreshToken,
  refreshTokenUrl,
  logout,
  setRefreshedTokens,
});
